import unit from "../unit";

/**
 * Returns box-shadow (defined in theme object)
 *
 * @param theme - Theme object
 * @param size - Size of box-shadow
 * @param isInverse - Sets if box shadow should be placed upside down
 * @returns Calculated box-shadow values
 */
var getBoxShadow = function getBoxShadow(theme, size) {
  var isInverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var _theme$boxShadow$size = theme.boxShadow[size],
    horizontalOffset = _theme$boxShadow$size.horizontalOffset,
    verticalOffset = _theme$boxShadow$size.verticalOffset,
    blur = _theme$boxShadow$size.blur,
    color = _theme$boxShadow$size.color;
  return "".concat(unit(horizontalOffset), " ").concat(unit(isInverse ? -1 * verticalOffset : verticalOffset), " ").concat(unit(blur), " ").concat(color);
};
export default getBoxShadow;